import { InjectionToken } from '@angular/core';
import { ErrorHandlerOptions } from '../interfaces/error-handler-options';
import { errorHandlerOptionsDefaults } from '../constants/error-handler-options.defaults';

export const ERROR_HANDLER_OPTIONS = new InjectionToken<ErrorHandlerOptions>(
  'ERROR_HANDLER_OPTIONS',
  { factory: () => ({ ...errorHandlerOptionsDefaults }) },
);
